import { Link } from "react-router-dom";
import "../assets/styles/navigation.css";
import { CiMenuFries } from "react-icons/ci";
import { MdOutlineClose } from "react-icons/md";
import { useState } from "react";

function Navigation(){

    const [isOpened, setIsopened] = useState(true);

    const clickHandler = () => {
        setIsopened(!isOpened)
    }
    return(
        <div className="navigation">
            <nav className="navigation-container">
                <ul className="navigation-list">
                    <li className="navigation-items">
                        <Link className="navigation-link navigation-logo" to="/">ty-<span className="logo-red">m</span>e</Link>
                    </li>
                    <li className="navigation-items burger-menu" onClick={clickHandler}>
                        <button className="navigation-link" to="/">
                        {isOpened ? 
                        <CiMenuFries className="burger-menu-icon" /> :
                        <MdOutlineClose  className="burger-menu-icon" />
                        }
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Navigation;
